import { runDemo } from "../shared/demoRunner";
import { createRibbonsScene } from "./scene";

runDemo({
    createScene: createRibbonsScene,
});
